import React from "react";
import Card from "../ui/card/Card";
import Image from "../common/Image";
import Stack from "../ui/Stack";

const ProductListItem = ({item, cartItem, quantity, onIncreaseQuantity, onDecreaseQuantity, onAddToCart}) => {
    return (
        <div className="col-md-12 col-xl-6 mb-4">
            <Card className="border-0">
                <div className="row g-5">
                    <div className="col-xl-5">
                        <div className="ratio ratio-4x3">
                            <Image className="rounded-2" src={item.image} alt={item.name}/>
                        </div>
                    </div>
                    <div className="col-xl-7">
                        <h5 className="position-relative">
                            {item.name}
                            <span
                                className={`position-absolute top-0 end-0 p-1 border border-light rounded-circle ${item.additionalDetails?.isVeg ? "bg-success" : "bg-danger"}`}>
                                <span className="visually-hidden">isveg</span>
                            </span>
                        </h5>
                        <h6 className="text-danger fs-sm">
                            {item.tags.map((tag) => tag.name).join(", ")}
                        </h6>
                        <Stack className="fs-5 flex-column align-items-baseline  mb-3 gap-0">
                            <b>&#8377;{item.sellPrice}</b>
                            {item?.stock && <p className="fs-sm m-0 fw-medium text-secondary">In Stock: <span className="text-primary">{item?.stock}</span></p>}
                        </Stack>
                        {cartItem ? (
                            <Stack className="d-inline-flex justify-content-between">
                                <button
                                    className="btn bg-primary bg-opacity-25 rounded-2 d-flex align-items-center justify-content-center"
                                    style={{width: 30, height: 30}}
                                    onClick={() => onDecreaseQuantity(item.id, item.stock)}
                                    disabled={quantity === 0}
                                >
                                    -
                                </button>
                                <input
                                    className="form-control mx-1 fs-sm fw-medium py-1 border-primary rounded-2 text-center"
                                    value={quantity}
                                    readOnly
                                    style={{width: 50}}
                                />
                                <button
                                    className="btn bg-primary bg-opacity-25 rounded-2 d-flex align-items-center justify-content-center"
                                    style={{width: 30, height: 30}}
                                    onClick={() => onIncreaseQuantity(item.id, item.stock)}
                                    disabled={quantity >= item.stock}
                                >
                                    +
                                </button>
                            </Stack>
                        ) : (

                            <button
                                className="btn bg-primary bg-opacity-25 fs-sm fw-medium rounded-2 py-1"
                                onClick={() => onAddToCart(item)}
                                disabled={item.stock <= 0}
                            >
                                Add to Cart
                            </button>
                        )}
                    </div>
                </div>
            </Card>
        </div>
    );
}
export default ProductListItem;
